export class Policy {
  value?: boolean;

  tooltip?: string;

  constructor(policy: Partial<Policy> = {}) {
    this.value = policy.value ?? false;
    this.tooltip = policy.tooltip ?? '';
  }
}
